import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

class About extends Component {
  componentDidMount() {
    document.getElementById('root').classList.remove('welcome');
    document.getElementById('foo').classList.add('overflow');
  }
  render() {
    return (
      <div className="sub-page">
        <Helmet>
          <title>STech - 404 — Page Not Found</title>
          <meta
            name="description"
            content="STech - Page Not Found"
          />
        </Helmet>
        <section className="clearfix notfound">
          <div className="container">
            <div className="center">
              <h1 className="fadeInUp">Oops!</h1>
              <h4 className="fadeInUp">404 — Page Not Found</h4>
              <p className="fadeInUp">
                The page you are looking for is temporarily
                unavailable.
                    <br />
              </p>
              <Link to="/" className="fadeInUp btn">
                <span className="notfoundButton">GO HOME</span>
              </Link>

              <p className="fadeInUp">
                <br />
                If you keep coming back here please{" "}
                <Link to="/contact">contact us</Link>.
                  </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default About
